import React, { Component } from 'react'
import {siteLastContact, siteDCAPType} from '../database/apiv2SiteAccessor';
import { formatTimeAgo, UTCTimeAgo} from '../timeFunctions/timeFns';
import MapPane from './MapPane'
import { siteAccessCode, ownerRBC } from "../database/apiv2SiteAccessor";
import { urlGetActiveSubscriptionStatus, urlGetStripeSession } from "../database/apiUrls";
import SecondServer from "../database/SecondServer";
import SystemInfo from './SystemInfo'
import {myRBC, displayOwner} from '../Utils/miscRefactors'

import './overview.css'
import './ContactPane.css'

export const ActivateSubscriptionButton = ({ onClick, accessCode, btnLabel }) => {
  const handleActivateSubClick = () => {
    onClick(accessCode);
  };

  if (!btnLabel)
    return null
  return (
    <button className="activateSubscriptionButton" onClick={handleActivateSubClick}>
      {btnLabel}
    </button>
  );
};

const ManageSubscriptionButton = ({ onClick, accessCode, pastDue, btnLabel }) => {
  const handleManageSubClick = () => {
    onClick(accessCode);
  };

  if (!btnLabel)
    return null
  if (pastDue){
    return (
      <button className="manageSubscriptionButtonPastDue" onClick={handleManageSubClick}>
        {btnLabel}
      </button>
    );
  } else {
    return (
      <button className="manageSubscriptionButton" onClick={handleManageSubClick}>
        {btnLabel}
      </button>
    );
  }
};

export default class ContactPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forceUpd: props?.forceUpd ?? 0,
    }
  }
  async componentDidUpdate(prevProps) {
    if (prevProps.streetView !== this.props.streetView) {
      this.setState ({forceUpd: this.state.forceUpd+1})
    }

    /*if (prevProps.forceUpd !== this.props.forceUpd) {
      const ss = new SecondServer(this.props)
      const ac = siteAccessCode(this.props.getActiveSite())
      const upd = await ss.apiData(urlSites(undefined, ac))
      if (upd?.data?.data) {
        const cache = upd.data.data[0].site_details
        this.props.updateSiteListCache(cache)
        this.setState({forceUpd: this.state.forceUpd+1})
      }
    }*/
  }
  formField (label, data, width='w-100') {
    return (
      <label className={"form-label site-label "+width}>{label}
        <input type="text" id={label} className="form-control display-style" value={data} readOnly/>
      </label>
    )
  }
  range (dcap) {
    return dcap.startsWith("TW-205") ? "MAX" : "Standard"
  }
  handleActivateSubscription = async (accessCode) => {
    console.log('Activate Subscription clicked for access code:', accessCode);

    // Get the Stripe Session
    const site = this.props.getActiveSite();
    const ss = new SecondServer(this.props);

    //check if there is subscription is active using API call, since the user might return to this page after already subscribing
    const subscriptioninfo = await ss.apiData(urlGetActiveSubscriptionStatus(siteAccessCode(site)));
    if (subscriptioninfo?.data?.status === 'Inactive'){
      const stripeSessionResponse = await ss.apiInsertData(urlGetStripeSession(siteAccessCode(site)));
      let targeturl = stripeSessionResponse?.data?.data?.result?.message;
      if (targeturl != null){
        console.log('Opening Stripe Session');
        //Type 1 - Replace with the target URL in the same window
        //window.location.href = 'https://www.google.com';

        //Type 2 = Open the targetURL in a new tab
        window.open(targeturl);
      }
    } else if (subscriptioninfo?.data?.status === 'Active'){ //this might happen if the user returns to this page after subscribing
      //change the state
      this.props.setSubcriptionStatus();
      //pop an alert
      console.log('Subscription already Active');
      this.props.showAlert('Sorry!',
                            'The subscription for this Cellular DCAP is already active.',
                            0,
                          );
    }
  };

  handleManageSubscription = (accessCode) => {
    // Implement your logic here - e.g., navigate to a details page, display a modal
    console.log('Manage Subscription clicked for access code:', accessCode);
    const site = this.props.getActiveSite()
    const dcapConn = site?.site_details?.tsm_conn_type
    if (dcapConn && dcapConn.toLowerCase() === 'ethernet') 
      this.handleActivateSubscription (siteAccessCode(site))
    else
      this.props.history.push('/billing');
  };

  render(){
    const site = this.props.getActiveSite();
    const rcv = siteLastContact(site)
    const ago = formatTimeAgo(UTCTimeAgo(rcv))
    const dcap = siteDCAPType(site) ?? 'Not Available'
    const isCellModule = this.props.isCellModule;
    const hasActiveSubscription = this.props.hasActiveSubscription;
    const userIsSubscriberForThisSite = this.props.userIsSubscriberForThisSite;
    const subscriptionPastDue = this.props.subscriptionPastDue;
    const status = this.props.pushText
    const owner = displayOwner (ownerRBC(site), myRBC(this.props)) 
    return (
      <div className="site-contact">
        <span className="site-contact-text">Last Contact Time</span>
        <span className="contact-ago"> {ago} ago</span>
        <MapPane {...this.props} />
        <div className='display-form'>
            <SystemInfo range={this.range(dcap)} {...this.props} />
            {this.formField("Owner", owner, "siteOwner")}
            {this.formField("DCAP PN", dcap)}
            <div>
            {this.formField("Connection Type", site?.site_details?.tsm_conn_type, 'w-50' )}
            {isCellModule === true && hasActiveSubscription === false && <ActivateSubscriptionButton onClick={this.handleActivateSubscription} 
              accessCode={siteAccessCode(site)} btnLabel={this.props?.btnLabel}/>}
            {isCellModule === true && hasActiveSubscription === true && userIsSubscriberForThisSite === true && 
              <ManageSubscriptionButton onClick={this.handleManageSubscription} accessCode={siteAccessCode(site)}
                pastDue={subscriptionPastDue} btnLabel={this.props?.btnLabel}/>}
            {isCellModule === true && hasActiveSubscription === true && userIsSubscriberForThisSite === true && subscriptionPastDue === true && <span className="subPastDue">{status ?? 'Past Due'}</span>}
            {isCellModule === true && hasActiveSubscription === true && !userIsSubscriberForThisSite === true && !subscriptionPastDue === true && <span className="subNotPastDue">{status ?? 'Subscription Active'}</span>}
            {isCellModule === true && hasActiveSubscription === true && !userIsSubscriberForThisSite === true && subscriptionPastDue === true && <span className="subPastDue">{status ?? 'Subscription Past Due'}</span>}
            </div>
        </div>
      </div>
    )
  }
}